import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.addScorecard`,
    defaultMessage: 'Add scorecard',
  },
  scorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.scorecard`,
    defaultMessage: 'Scorecard',
  },
  scorecardPlaceholder: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.scorecardPlaceholder`,
    defaultMessage: 'Please select...',
  },
  assigneeNoteInterviewHost: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.assigneeNoteInterviewHost`,
    defaultMessage: 'This scorecard will be assigned to the interview host.',
    description:
      'Tells the recruiter that the host of the booked interview session fills in this scorecard',
  },
  assigneeNoteOpeningOwner: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.assigneeNoteOpeningOwner`,
    defaultMessage: 'This scorecard will be assigned to the opening owner.',
    description:
      'Tells the recruiter that the owner of the job opening fills in this scorecard',
  },
});
